import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import {
  ResponsiveContainer,
  LineChart,
  Line,
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from "recharts";

export default function DashboardCharts({ clientId }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const params = { days: 30 };
        if (clientId) params.client_id = clientId;
        const r = await api.get("/dashboard/charts", { params });
        setData(r.data);
      } catch (_) { setData(null); }
    })();
  }, [clientId]);

  if (!data) return null;

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-px bg-neutral-900 border border-neutral-900">
      <div className="bg-neutral-950 p-6">
        <div className="text-[10px] uppercase tracking-[0.3em] text-neutral-500 mb-6">
          Edited vs Posted · Last 30 days
        </div>
        <div className="h-64">
          <ResponsiveContainer width="100%" height="100%">
            <AreaChart data={data.edited_vs_posted}>
              <defs>
                <linearGradient id="g-edited" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="0%" stopColor="#8B5CF6" stopOpacity={0.5} />
                  <stop offset="100%" stopColor="#8B5CF6" stopOpacity={0} />
                </linearGradient>
                <linearGradient id="g-posted" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="0%" stopColor="#00C97A" stopOpacity={0.5} />
                  <stop offset="100%" stopColor="#00C97A" stopOpacity={0} />
                </linearGradient>
              </defs>
              <CartesianGrid stroke="#171717" vertical={false} />
              <XAxis dataKey="date" stroke="#525252" tick={{ fontSize: 10, fill: "#737373" }} tickFormatter={(d) => d.slice(5)} />
              <YAxis stroke="#525252" tick={{ fontSize: 10, fill: "#737373" }} allowDecimals={false} />
              <Tooltip contentStyle={{ background: "#0A0A0A", border: "1px solid #262626", borderRadius: 0, fontSize: 12 }} />
              <Legend wrapperStyle={{ fontSize: 10, textTransform: "uppercase", letterSpacing: "0.2em", color: "#737373" }} />
              <Area type="monotone" dataKey="edited" stroke="#8B5CF6" fill="url(#g-edited)" strokeWidth={2} name="Edited" />
              <Area type="monotone" dataKey="posted" stroke="#00C97A" fill="url(#g-posted)" strokeWidth={2} name="Posted" />
            </AreaChart>
          </ResponsiveContainer>
        </div>
      </div>

      <div className="bg-neutral-950 p-6">
        <div className="text-[10px] uppercase tracking-[0.3em] text-neutral-500 mb-6">
          On-time Delivery · Editor vs SMM
        </div>
        <div className="h-64">
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={data.ontime}>
              <CartesianGrid stroke="#171717" vertical={false} />
              <XAxis dataKey="date" stroke="#525252" tick={{ fontSize: 10, fill: "#737373" }} tickFormatter={(d) => d.slice(5)} />
              <YAxis stroke="#525252" tick={{ fontSize: 10, fill: "#737373" }} domain={[0, 100]} tickFormatter={(v) => `${v}%`} />
              <Tooltip contentStyle={{ background: "#0A0A0A", border: "1px solid #262626", borderRadius: 0, fontSize: 12 }} formatter={(v) => v == null ? "—" : `${v}%`} />
              <Legend wrapperStyle={{ fontSize: 10, textTransform: "uppercase", letterSpacing: "0.2em", color: "#737373" }} />
              <Line type="monotone" dataKey="editor_ontime_pct" stroke="#8B5CF6" strokeWidth={2} dot={{ r: 2 }} connectNulls name="Editor" />
              <Line type="monotone" dataKey="smm_ontime_pct" stroke="#00C97A" strokeWidth={2} dot={{ r: 2 }} connectNulls name="SMM" />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
}
